
const notificationsLoading = state => state.notificationsLoading

const noMoreNotifications = state => state.noMoreNotifications
const notificationsError = state => state.notificationsError

const notifications = state => {
  if (state.notifications) {
    let obj = null
    let totalNew = state.notifications.filter(obj => obj.label === 'new')
    let totalEarlier = state.notifications.filter(obj => obj.label === 'earlier')
    if (totalEarlier.length > 0) {
      obj = { stateDivider: true }
      return [...totalNew, obj, ...totalEarlier]
    } else {
      return state.notifications
    }
  } else {
    return null
  }
}

const hasNew = state => {
  if (state.notifications) {
    return state.notifications.filter(obj => obj.label === 'new').length > 0
  } else {
    return null
  }
}

const totalUnread = state => state.totalUnread

const hasMoreNotifications = state => state.totalNotifications > state.notificationsPage * state.notificationsPerPage

export default {
  notifications,
  notificationsLoading,
  noMoreNotifications,
  hasMoreNotifications,
  totalUnread,
  notificationsError,
  hasNew
}
